import React from 'react';

const Content = ({ children }) => {
  return <main className="relative flex-grow container mx-auto bg-white">{children}</main>;
};

export default Content;
